<label>{{ label }}</label>
<ng-select
  [(ngModel)]="value"
  (change)="onChange()"
  [items]="clientTypes"
  bindValue="id"
  bindLabel="type"
  class="client-type-input"
>
</ng-select>
